import React, {useEffect, useRef, useState} from 'react'

const RENT_TYPE_OPTIONS = [
    {
        value: 'direct',
        label: '24/7 met App',
        icon: 'bi bi-lightning-charge',
        description: '24/7 snel geregeld via de app, zonder balie \n' +
            '→ Ideaal voor een snelle rit, vanaf 1 uur huren'
    },
    // {
    //     value: 'online',
    //     label: 'Online',
    //     icon: 'bi bi-display',
    //     description: 'Vooraf regelen, geen wachttijd, alleen sleutel ophalen'
    // },
    {
        value: 'nearby',
        label: 'P2P',
        icon: 'bi bi-house-door',
        description: 'Autodelen met mensen bij jou in de buurt \n' +
            '→ Vaak voordeliger voor een dagje weg'
    },
    {
        value: 'rental-company',
        label: 'Autoverhuurbedrijf',
        icon: 'bi bi-buildings',
        description: 'Met service en persoonlijk contact \n' +
            '→ Voor langere huur of specifieke wensen'
    }
]

const RentTypeFilters = ({selectedValues = [], onChange}) => {
    const [openInfoValue, setOpenInfoValue] = useState(null)
    const infoPopoverRef = useRef(null)

    useEffect(() => {
        if (!openInfoValue) return

        const onOutsideClick = (event) => {
            if (!infoPopoverRef.current) return
            if (!infoPopoverRef.current.contains(event.target)) {
                setOpenInfoValue(null)
            }
        }

        const onEscape = (event) => {
            if (event.key === 'Escape') {
                setOpenInfoValue(null)
            }
        }

        document.addEventListener('mousedown', onOutsideClick)
        document.addEventListener('keydown', onEscape)

        return () => {
            document.removeEventListener('mousedown', onOutsideClick)
            document.removeEventListener('keydown', onEscape)
        }
    }, [openInfoValue])

    const onCheckboxChange = (value) => {
        const isSelected = selectedValues.includes(value)
        const nextValues = isSelected
            ? selectedValues.filter(item => item !== value)
            : [...selectedValues, value]

        if (onChange) {
            onChange(nextValues)
        }
    }

    const onInfoToggle = (value) => {
        setOpenInfoValue(prev => (prev === value ? null : value))
    }

    return (
        <div className="front-rent-type-filter-wrap">
            <div className="front-rent-type-filter__header">
                <p className="front-rent-type-filter__title">Type verhuur</p>
            </div>
            <fieldset className="front-rent-type-filter" aria-label="Selecteer huurtype">
                {
                    RENT_TYPE_OPTIONS.map(({value, label, icon, description}) => {
                        const inputId = `rent-type-${value}`
                        const isChecked = selectedValues.includes(value)
                        const isInfoOpen = openInfoValue === value
                        const popoverId = `rent-type-info-popover-${value}`

                        return (
                            <div className="front-rent-type-filter__option" key={value}>
                                <input
                                    id={inputId}
                                    className="front-rent-type-filter__input"
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={() => onCheckboxChange(value)}
                                />
                                <div className="front-rent-type-filter__optionRow">
                                    <label htmlFor={inputId} className="front-rent-type-filter__label">
                                        <i className={`${icon} front-rent-type-filter__leading-icon`} aria-hidden="true"></i>
                                        <span className="front-rent-type-filter__labelText">{label}</span>
                                    </label>
                                    <div
                                        className="front-rent-type-filter__info"
                                        ref={isInfoOpen ? infoPopoverRef : null}
                                    >
                                        <button
                                            type="button"
                                            className="front-rent-type-filter__infoBtn"
                                            aria-expanded={isInfoOpen}
                                            aria-controls={popoverId}
                                            aria-label={`Informatie over ${label}`}
                                            onClick={(event) => {
                                                event.preventDefault()
                                                event.stopPropagation()
                                                onInfoToggle(value)
                                            }}
                                        >
                                            i
                                        </button>
                                        {
                                            isInfoOpen && (
                                                <div
                                                    id={popoverId}
                                                    className="front-rent-type-filter__popover"
                                                    role="tooltip"
                                                >
                                                    <p className="front-rent-type-filter__popoverText">{description}</p>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <label
                                        htmlFor={inputId}
                                        className="front-rent-type-filter__checkboxLabel"
                                        aria-label={`Selecteer ${label}`}
                                    >
                                        <span className="front-rent-type-filter__checkbox" aria-hidden="true">
                                            <i className="bi bi-check2"></i>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        )
                    })
                }
            </fieldset>
        </div>
    )
}

export default RentTypeFilters
